import { useMemo, useSyncExternalStore } from 'react';
import { getSessionSnapshot, getServerSession, subscribeSession } from '@/lib/sessionStore';
import { type Session } from '@/lib/session';
import { capabilitiesForRole, type AppCapabilities, type AppRole } from './permissions';

export interface AuthState {
  session: Session | null;
  user: Session['user'] | null;
  token: string | null;
  capabilities: AppCapabilities;
}

export function useAuth(): AuthState {
  const session = useSyncExternalStore(subscribeSession, getSessionSnapshot, getServerSession);
  const role = session?.user?.role as AppRole | undefined;
  const capabilities = useMemo(() => capabilitiesForRole(role), [role]);

  return {
    session,
    user: session?.user ?? null,
    token: session?.token ?? null,
    capabilities,
  };
}
